<template>
  <div>
    <div v-if="datas" class="mcontainer">
      <div class="mleft">
        <div class="mcard">
          <div class="mcard--title">
            {{ $t("organization.dashboard.task-title") }}
            <span>
              {{ $t("task.completed") }}
              {{ datas.tasks.total }}/{{ datas.tasks.completedCount }}</span
            >
          </div>
          <hr />
          <div>
            <div>
              <doughnut-chart
                :backgroundColors="['gray', 'red', '#FF7C48', '#2998FF', '#9440FF', '#2ECD06']"
                :labels="taskStatusDataSet.labels"
                :datas="taskStatusDataSet.datas"
                @click="goToTaskList"
              />
              <div class="chart-label">{{ $t("organization.dashboard.task-status-info") }}</div>
            </div>
          </div>
        </div>
        <div class="mcard">
          <div class="mcard--title">
            {{ $t("organization.dashboard.question-title") }}
            <span>
              {{ $t("task.completed") }}
              {{ datas.questionSets.total }}/{{ datas.questionSets.completedCount }}</span
            >
          </div>

          <hr />
          <div>
            <div>
              <doughnut-chart :labels="[$t('task.completed'), $t('task.un-completed')]" :datas="questionSetCompleteData" @click="goToQuestionSetList" />
              <div class="chart-label">{{ $t("organization.dashboard.total-question-set-info") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mcalendar-card">
        <div class="mcard--title mx-4 pt-2">
          <div class="col-md-6">
            {{ $t("organization.dashboard.calendar") }}
            <label class="mcard--subtitle">{{ datas.tasks.unCompletedCount }} {{ $t("task.active") }}</label>
          </div>
          <div class="col-md-6">
            <span @click="changeRouter('/organization/tasks', 'list', undefined, 'organization')" class="float-right hand mt-4"> {{ $t("task.view-list") }}</span>
          </div>
        </div>
        <hr style="margin-top: 0;" />
        <full-calendar :events="calendarEvents" />
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from "./components/doughnut";
import { dateToStr } from "./components/event-utils";
import FullCalendar from "./components/fullcalendar";

export default {
  components: { FullCalendar, DoughnutChart },
  computed: {
    datas() {
      return this.$store.getters["organization/dashboard"];
    },
    questionSetCompleteData() {
      if (!this.datas) {
        return [];
      }
      return [this.datas.questionSets.completedCount, this.datas.questionSets.unCompletedCount];
    },
    calendarEvents() {
      if (!this.datas) {
        return [];
      }

      const events = [...this.datas.tasks.events, ...this.datas.policies.events];
      return events.map((i) => ({ ...i, start: dateToStr(new Date(i.start)) }));
    },
    taskCompleteData() {
      if (!this.datas) {
        return [];
      }
      return [this.datas.tasks.completedCount, this.datas.tasks.unCompletedCount];
    },

    taskStatusDataSet() {
      if (!this.datas?.tasks) {
        return {};
      }

      const labels = [];
      const datas = [];
      const links = {};

      Object.keys(this.datas.tasks.tasksByStatus).forEach((status) => {
        let label = this.$t("task.status.todo");
        if (status == "IN_PROGRESS") {
          label = this.$t("task.status.in-progress");
        } else if (status == "APPROVAL") {
          label = this.$t("task.status.approval");
        } else if (status == "UNWORKED") {
          label = this.$t("task.status.unworked");
        } else if (status == "NOT_FIT") {
          label = this.$t("task.status.not-fit");
        } else if (status == "DONE") {
          label = this.$t("task.status.done");
        }
        labels.push(label);

        links[status] = { viewType: "list", status, activeTab: "organization" };
        datas.push(this.datas.tasks.tasksByStatus[status]);
      });
      return { labels, datas, links };
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("organization/dashboard");
  },
  methods: {
    goToTaskList(event, elements) {
      const clickedIndex = elements[0].index;
      const clickedStatus = Object.keys(this.datas.tasks.tasksByStatus)[clickedIndex];

      if (elements && elements.length > 0) {
        const { viewType, status, activeTab } = this.taskStatusDataSet.links[clickedStatus];

        this.$router.push({
          path: "/organization/tasks",
          query: {
            viewType,
            status,
            activeTab,
          },
        });
      }
    },
    changeRouter(path, viewType, status, activeTab) {
      this.$router.push({
        path,
        query: {
          ...(viewType ? { viewType } : {}),
          ...(status ? { status } : {}),
          ...(activeTab ? { activeTab } : {}),
        },
      });
    },

    goToTaskList(event, elements) {
      const clickedIndex = elements?.[0]?.index;
      const clickedStatus = Object.keys(this.datas.tasks.tasksByStatus)[clickedIndex];

      if (elements && elements.length > 0) {
        const { viewType, status, activeTab } = this.taskStatusDataSet.links[clickedStatus];
        this.changeRouter("/organization/tasks", viewType, status, activeTab);
      }
    },
    goToQuestionSetList(event, elements) {
      const activeTab = "organization";
      //normalde org questionset'e yönlendimrke gerekiyor ama o sayfa henüz olmadığından istek üzerine ürün sayfasına yönlendirildi
      this.$router.push({ path: "/kvkk/question-set", query: { ...(activeTab ? { activeTab } : {}) } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dashboard";
</style>
